import createCache from '@emotion/cache';
import { CacheProvider, ThemeProvider } from '@emotion/react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import App from 'app';
import moment from 'moment-timezone';
import { MasonryProvider, SnackbarProvider } from 'providers';
import { HTML5toTouch } from 'rdndmb-html5-to-touch';
import { StrictMode } from 'react';
import { DndProvider } from 'react-dnd-multi-backend';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from 'store';
import theme from 'theme';
import GlobalStyle from 'theme/GlobalStyle';
import { TssCacheProvider } from 'tss-react';
import * as serviceWorker from './serviceWorker';

moment.tz.setDefault('Etc/UTC');

const muiCache = createCache({
  key: 'mui',
  prepend: true,
});

const tssCache = createCache({
  key: 'tss',
});

ReactDOM.render(
  <StrictMode>
    <Provider store={store}>
      <CacheProvider value={muiCache}>
        <TssCacheProvider value={tssCache}>
          <MuiThemeProvider theme={theme}>
            <ThemeProvider theme={theme}>
              <GlobalStyle />
              <LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment}>
                <BrowserRouter>
                  <SnackbarProvider>
                    <MasonryProvider>
                      <DndProvider options={HTML5toTouch}>
                        <App />
                      </DndProvider>
                    </MasonryProvider>
                  </SnackbarProvider>
                </BrowserRouter>
              </LocalizationProvider>
            </ThemeProvider>
          </MuiThemeProvider>
        </TssCacheProvider>
      </CacheProvider>
    </Provider>
  </StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// ========================================
